import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Empty, Row, Select, Spin } from "antd";
import { DefaultOptionType } from "antd/lib/select";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { TagModel } from "states/tag/tag.models";
import { fetchTagList, tagListSelector } from "states/tag/tag.slice";
import { TagModalComponent } from "./tag-modal";
export interface ITagSelectorProps {
  value?: number | number[];
  isMultiple?: boolean;
  onChange?: (values?: TagModel | TagModel[]) => void;
  bordered?: boolean;
  textAlign?: "right";
}

export function TagSelector(props: ITagSelectorProps) {
  const { value, isMultiple, onChange, bordered, textAlign } = props;
  const tagList = useSelector(tagListSelector, shallowEqual);
  const dispatch = useDispatch();
  const [isModal, setModal] = useState(false);
  const handleCloseModal = () => {
    setModal(false);
  };
  const handleOnModal = () => {
    setModal(true);
  };
  useEffect(() => {
    if (!value && tagList.length === 1 && onChange) {
      if (isMultiple) {
        onChange(tagList);
      } else {
        onChange(tagList[0]);
      }
    }
  }, [tagList]);

  return (
    <React.Fragment>
      <Select
        className={`w-100${textAlign ? ` text-${textAlign}` : ""}`}
        placeholder="Chọn tag"
        value={value}
        onChange={(e) => {
          if (onChange) {
            if (!isMultiple) {
              const tag = tagList.find((m) => m.id === e);
              onChange(tag);
              return;
            }
            if (!e) {
              onChange([]);
              return;
            }
            const ids = e as number[];
            let tags = [...tagList].filter((tag) => ids.includes(tag.id));
            onChange(tags);
          }
        }}
        showSearch
        filterOption={(input, option: any) => option.label.props.children.props.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
        }
        mode={isMultiple ? "multiple" : undefined}
        allowClear
        bordered={bordered}
        options={tagList.map(
          (tag) =>
            ({
              key: tag.id,
              value: tag.id,
              label: (
                <Row gutter={[12, 12]}>
                  <Col>{tag.tagName}</Col>
                </Row>
              ),
            } as  DefaultOptionType)
        )}
        notFoundContent={<Empty />}
        dropdownRender={(menu) => (
          <div>
            {menu}
            <Divider style={{ margin: "4px 0" }} />
            <div className="p-2">
              <Button
                type="primary"
                onClick={handleOnModal}
                icon={<PlusOutlined />}
              >
                Thêm mới
              </Button>
            </div>
          </div>
        )}
      ></Select>
      <TagModalComponent
        model={{} as TagModel}
        onModal={isModal}
        closeModal={handleCloseModal}
        onSuccess={() => {
          dispatch(fetchTagList());
        }}
        isUpdate={false}
      />
    </React.Fragment>
  );
}
